<div class="coaching-card-rep">
    <cmps-card-component
        class="insight-component-item"
        [cardNameLabel]="_i18n._9916_MY_COACHING | translate"
        [isLoading]="state.pending.reload"
        [hasExpandAction]="state.pending.hasData"
        [disabledDropdown]="true"
        [isExpanded]="_isExpanded"
        [refreshButtonTooltip]="
            _i18n._10067_RESET_CARD_TO_DEFAULT_VIEW | translate
        "
        [expandButtonTooltip]="
            _isExpanded === false
                ? (_i18n._10068_EXPAND_TO_COACHING_INSIGHT | translate)
                : ''
        "
        [hasRefreshAction]="_isExpanded === false && state.pending.hasData"
        (refreshAction)="_onReload()"
        (expandAction)="_onExpandClick()"
        [data]="bodyContent"
    ></cmps-card-component>
</div>

<ng-template #bodyContent>
    <ng-container *ngIf="!state.pending.hasData && !state.pending.reload">
        <div class="my-coaching-card--no-data">
            <h2 class="my-coaching-card--no-data-value">
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </h2>
        </div>
    </ng-container>
    <div class="main-body-container">
        <div *ngIf="_isExpanded === false">
            <div
                class="coaching-card-rep--accordion"
                *ngFor="let item of state?.dataset; let i = index"
            >
                <ng-container *ngIf="item.isVisible">
                    <button
                        class="accordion"
                        (click)="_toggleAccordion(i)"
                    >
                        {{ item.title }}
                        <span
                            *ngIf="item.counterLabel"
                            class="other-opportunity-counter"
                            >{{ item?.counterLabel }}</span
                        >
                    </button>
                    <div
                        class="panel"
                        [class.panel-visible]="!item.isOpened"
                    >
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <ng-container
                                    *ngIf="
                                        item.type ===
                                        _cardItemType.PENDING_COMMITMENTS
                                    "
                                >
                                    <thead class="table-header">
                                        <tr>
                                            <th
                                                scope="col"
                                                sortable="lastUpdated"
                                                [index]="i"
                                                (sort)="_onSort($event)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._7310_SESSION_DATE
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                sortable="behaviour"
                                                [index]="i"
                                                (sort)="_onSort($event, i)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._7334_BEHAVIOUR
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                sortable="subBehaviour"
                                                [index]="i"
                                                (sort)="_onSort($event)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._7336_SUB_BEHAVIOUR
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                sortable="goalKpi"
                                                [index]="i"
                                                (sort)="_onSort($event, i)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._7339_METRIC_NAME
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="table-body">
                                        <tr
                                            class="table-row-pending-cmts"
                                            *ngFor="
                                                let child of item.childItems
                                            "
                                            (click)="_navigate(child)"
                                        >
                                            <ng-container
                                                *ngIf="
                                                    child.isVisible ||
                                                    !item.isShowMoreEnabled
                                                "
                                            >
                                                <td>
                                                    {{
                                                        (child.opportunityItem
                                                            .lastUpdated
                                                            | date
                                                                : 'LLL-dd-yyyy') ||
                                                            '-'
                                                    }}
                                                </td>
                                                <td>
                                                    <div
                                                        class="td-ellipsis"
                                                        #tdBehaviour
                                                        [cmpsTooltipTrigger]="
                                                            _getTooltipData(
                                                                tdBehaviour,
                                                                child
                                                                    .opportunityItem
                                                                    .behaviour
                                                            )
                                                        "
                                                    >
                                                        <h5>
                                                            {{
                                                                child
                                                                    .opportunityItem
                                                                    .behaviour ||
                                                                    '-'
                                                            }}
                                                        </h5>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div
                                                        class="td-ellipsis"
                                                        #tdSubBehaviour
                                                        [cmpsTooltipTrigger]="
                                                            _getTooltipData(
                                                                tdSubBehaviour,
                                                                child
                                                                    .opportunityItem
                                                                    .subBehaviour
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            child
                                                                .opportunityItem
                                                                .subBehaviour ||
                                                                '-'
                                                        }}
                                                    </div>
                                                </td>
                                                <td>
                                                    {{
                                                        child.opportunityItem
                                                            .goalKpi || '-'
                                                    }}
                                                </td>
                                            </ng-container>
                                        </tr>
                                    </tbody>
                                </ng-container>
                                <ng-container
                                    *ngIf="item.type === _cardItemType.COACHED"
                                >
                                    <thead class="table-header">
                                        <tr>
                                            <th
                                                scope="col"
                                                sortable="behaviour"
                                                [index]="i"
                                                (sort)="_onSort($event, i)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._7334_BEHAVIOUR
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                sortable="subBehaviour"
                                                [index]="i"
                                                (sort)="_onSort($event)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._7336_SUB_BEHAVIOUR
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                sortable="aligned"
                                                [index]="i"
                                                (sort)="_onSort($event)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._10060_ALIGNED
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                sortable="goalKpi"
                                                [index]="i"
                                                (sort)="_onSort($event)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._10061_GOALED_KPI
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                sortable="pctImprovement"
                                                [index]="i"
                                                (sort)="_onSort($event)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._10062_PERCENT_IMPROVEMENT
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                sortable="daysActive"
                                                [index]="i"
                                                (sort)="_onSort($event)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._9473_DAYS_ACTIVE
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                            <ng-container
                                                *ngIf="item.isTableExpanded"
                                            >
                                                <th
                                                    scope="col"
                                                    sortable="currentActual"
                                                    [index]="i"
                                                    (sort)="_onSort($event)"
                                                >
                                                    <div
                                                        class="table-header-container"
                                                    >
                                                        <h5>
                                                            {{
                                                                _i18n._4106_CURRENT_ACTUAL
                                                                    | translate
                                                            }}
                                                        </h5>
                                                        <cmps-icon
                                                            svgIcon="menu-down"
                                                        ></cmps-icon>
                                                    </div>
                                                </th>
                                                <th
                                                    scope="col"
                                                    sortable="pctTarget"
                                                    [index]="i"
                                                    (sort)="_onSort($event)"
                                                >
                                                    <div
                                                        class="table-header-container"
                                                    >
                                                        <h5>
                                                            {{
                                                                _i18n._768___TO_TARGET
                                                                    | translate
                                                            }}
                                                        </h5>
                                                        <cmps-icon
                                                            svgIcon="menu-down"
                                                        ></cmps-icon>
                                                    </div>
                                                </th>
                                                <th
                                                    scope="col"
                                                    sortable="pctToGoal"
                                                    [index]="i"
                                                    (sort)="_onSort($event)"
                                                >
                                                    <div
                                                        class="table-header-container"
                                                    >
                                                        <h5>
                                                            {{
                                                                _i18n._7367___TO_GOAL
                                                                    | translate
                                                            }}
                                                        </h5>
                                                        <cmps-icon
                                                            svgIcon="menu-down"
                                                        ></cmps-icon>
                                                    </div>
                                                </th>
                                                <th
                                                    scope="col"
                                                    sortable="lastUpdated"
                                                    [index]="i"
                                                    (sort)="_onSort($event)"
                                                >
                                                    <div
                                                        class="table-header-container"
                                                    >
                                                        <h5>
                                                            {{
                                                                _i18n._9923_LAST_UPDATED
                                                                    | translate
                                                            }}
                                                        </h5>
                                                        <cmps-icon
                                                            svgIcon="menu-down"
                                                        ></cmps-icon>
                                                    </div>
                                                </th>
                                            </ng-container>
                                            <th>
                                                <button
                                                    class="table-expand-button cmps-button--no-bg"
                                                    cmpsButton
                                                    [cmpsTooltipTrigger]="
                                                        (!item.isTableExpanded
                                                            ? _i18n._10069_CLICK_TO_SHOW_ADDITIONAL_COLUMNS
                                                            : _i18n._10070_CLICK_TO_HIDE_ADDITIONAL_COLUMNS
                                                        ) | translate
                                                    "
                                                    trigger="hover"
                                                    (click)="
                                                        _onTableExpandClick(i)
                                                    "
                                                >
                                                    <cmps-icon
                                                        [svgIcon]="
                                                            !item.isTableExpanded
                                                                ? 'arrow-expand-right'
                                                                : 'arrow-expand-left'
                                                        "
                                                    ></cmps-icon>
                                                </button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <ng-container
                                        *ngIf="item.noDataLabel; else tableBody"
                                    >
                                        <ng-container
                                            *ngTemplateOutlet="
                                                noOpportunities;
                                                context: { $implicit: item }
                                            "
                                        ></ng-container>
                                    </ng-container>
                                    <ng-template #tableBody>
                                        <tbody class="table-body">
                                            <tr
                                                *ngFor="
                                                    let child of item.childItems
                                                "
                                            >
                                                <ng-container
                                                    *ngIf="
                                                        child.isVisible ||
                                                        !item.isShowMoreEnabled
                                                    "
                                                >
                                                    <td>
                                                        <button
                                                            class="active-plans-behaviour-btn cmps-button--no-bg"
                                                            cmpsButton
                                                            (click)="
                                                                _navigate(
                                                                    child,
                                                                    true
                                                                )
                                                            "
                                                        >
                                                            <span
                                                                class="td-ellipsis"
                                                                #tdBehaviour
                                                                [cmpsTooltipTrigger]="
                                                                    _getTooltipData(
                                                                        tdBehaviour,
                                                                        child
                                                                            .opportunityItem
                                                                            .behaviour
                                                                    )
                                                                "
                                                            >
                                                                <h5>
                                                                    {{
                                                                        child
                                                                            .opportunityItem
                                                                            .behaviour ||
                                                                            '-'
                                                                    }}
                                                                </h5>
                                                            </span>
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <div
                                                            class="td-ellipsis"
                                                            #tdSubBehaviour
                                                            [cmpsTooltipTrigger]="
                                                                _getTooltipData(
                                                                    tdSubBehaviour,
                                                                    child
                                                                        .opportunityItem
                                                                        .subBehaviour
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                child
                                                                    .opportunityItem
                                                                    .subBehaviour ||
                                                                    '-'
                                                            }}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div
                                                            [ngSwitch]="
                                                                child
                                                                    .opportunityItem
                                                                    .aligned
                                                            "
                                                        >
                                                            <ng-container
                                                                *ngSwitchCase="
                                                                    _coachingTypeRepCard[
                                                                        _coachingType
                                                                            .COACHED
                                                                    ]
                                                                "
                                                            >
                                                                <button
                                                                    cmpsButton
                                                                    class="cmps-btn-aligned"
                                                                >
                                                                    <cmps-icon
                                                                        svgIcon="check"
                                                                    ></cmps-icon>
                                                                </button>
                                                            </ng-container>
                                                            <ng-container
                                                                *ngSwitchCase="
                                                                    _coachingTypeRepCard[
                                                                        _coachingType
                                                                            .NON_OA
                                                                    ]
                                                                "
                                                            >
                                                                <button
                                                                    cmpsButton
                                                                    class="cmps-btn-not-aligned"
                                                                >
                                                                    <cmps-icon
                                                                        svgIcon="exclamation"
                                                                    ></cmps-icon>
                                                                </button>
                                                            </ng-container>
                                                            <ng-container
                                                                *ngSwitchDefault
                                                            >
                                                                <button
                                                                    cmpsButton
                                                                    class="cmps-btn-aligned-no-data"
                                                                >
                                                                    <span>{{
                                                                        _i18n._9402_NA
                                                                            | translate
                                                                    }}</span>
                                                                </button>
                                                            </ng-container>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {{
                                                            child
                                                                .opportunityItem
                                                                .goalKpi || '-'
                                                        }}
                                                    </td>
                                                    <td>
                                                        <div
                                                            class="goal-improvement-info"
                                                        >
                                                            <cmps-icon
                                                                *ngIf="
                                                                    child
                                                                        .opportunityItem
                                                                        ?.pctImprovement >
                                                                    0
                                                                "
                                                                svgIcon="trending-up"
                                                                class="trending-up"
                                                            ></cmps-icon>
                                                            <cmps-icon
                                                                *ngIf="
                                                                    child
                                                                        .opportunityItem
                                                                        ?.pctImprovement <
                                                                    0
                                                                "
                                                                svgIcon="trending-down"
                                                                class="trending-down"
                                                            ></cmps-icon>
                                                            <span
                                                                *ngIf="
                                                                    child
                                                                        .opportunityItem
                                                                        ?.pctImprovement ||
                                                                        child
                                                                            .opportunityItem
                                                                            ?.pctImprovement ===
                                                                            0;
                                                                    else noImprovementSince
                                                                "
                                                            >
                                                                {{
                                                                    (child
                                                                        .opportunityItem
                                                                        ?.pctImprovement
                                                                        | percent
                                                                            : '1.0-1') ||
                                                                        '-'
                                                                }}
                                                            </span>
                                                            <ng-template
                                                                #noImprovementSince
                                                            >
                                                                <span>{{
                                                                    _i18n._9402_NA
                                                                        | translate
                                                                }}</span>
                                                            </ng-template>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {{
                                                            child
                                                                .opportunityItem
                                                                .daysActive
                                                        }}
                                                    </td>
                                                    <ng-container
                                                        *ngIf="
                                                            item.isTableExpanded
                                                        "
                                                    >
                                                        <td>
                                                            {{
                                                                child
                                                                    .opportunityItem
                                                                    .currentActual
                                                                    ? (child
                                                                          .opportunityItem
                                                                          .currentActual
                                                                      | number
                                                                          : '1.0-2')
                                                                    : '-'
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                child
                                                                    .opportunityItem
                                                                    .pctTarget
                                                                    ? (child
                                                                          .opportunityItem
                                                                          .pctTarget
                                                                      | percent
                                                                          : '1.0-2')
                                                                    : '-'
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                child
                                                                    .opportunityItem
                                                                    .pctToGoal
                                                                    ? (child
                                                                          .opportunityItem
                                                                          .pctToGoal
                                                                      | percent
                                                                          : '1.0-2')
                                                                    : '-'
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                (child
                                                                    .opportunityItem
                                                                    .lastUpdated
                                                                    | date
                                                                        : 'LLL-dd-yyyy') ||
                                                                    '-'
                                                            }}
                                                        </td>
                                                    </ng-container>
                                                </ng-container>
                                            </tr>
                                        </tbody>
                                    </ng-template>
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        item.type === _cardItemType.UNCOACHED
                                    "
                                >
                                    <thead class="table-header">
                                        <tr>
                                            <th
                                                scope="col"
                                                sortable="metricName"
                                                [index]="i"
                                                (sort)="_onSort($event, i)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._7339_METRIC_NAME
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                sortable="currentActual"
                                                [index]="i"
                                                (sort)="_onSort($event)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._4106_CURRENT_ACTUAL
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                sortable="pctTarget"
                                                [index]="i"
                                                (sort)="_onSort($event)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._768___TO_TARGET
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>

                                            <th
                                                scope="col"
                                                sortable="daysAsAnOpp"
                                                [index]="i"
                                                (sort)="_onSort($event)"
                                            >
                                                <div
                                                    class="table-header-container"
                                                >
                                                    <h5>
                                                        {{
                                                            _i18n._10063_DAYS_AS_AN_OPPORTUNITY
                                                                | translate
                                                        }}
                                                    </h5>
                                                    <cmps-icon
                                                        svgIcon="menu-down"
                                                    ></cmps-icon>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <ng-container
                                        *ngIf="item.noDataLabel; else tableBody"
                                    >
                                        <ng-container
                                            *ngTemplateOutlet="
                                                noOpportunities;
                                                context: { $implicit: item }
                                            "
                                        ></ng-container>
                                    </ng-container>
                                    <ng-template #tableBody>
                                        <tbody class="table-body">
                                            <tr
                                                *ngFor="
                                                    let child of item.childItems
                                                "
                                            >
                                                <ng-container
                                                    *ngIf="
                                                        child.isVisible ||
                                                        !item.isShowMoreEnabled
                                                    "
                                                >
                                                    <td>
                                                        <button
                                                            class="table-metric-column-btn cmps-button--no-bg"
                                                            cmpsButton
                                                            (click)="
                                                                _onMetricClick(
                                                                    child
                                                                        .opportunityItem
                                                                        ?.metricId
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                child
                                                                    .opportunityItem
                                                                    .metricName ||
                                                                    '-'
                                                            }}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        {{
                                                            child
                                                                .opportunityItem
                                                                .currentActual
                                                                ? (child
                                                                      .opportunityItem
                                                                      .currentActual
                                                                  | number
                                                                      : '1.0-2')
                                                                : '-'
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            child
                                                                .opportunityItem
                                                                .pctTarget
                                                                ? (child
                                                                      .opportunityItem
                                                                      .pctTarget
                                                                  | percent
                                                                      : '1.0-2')
                                                                : '-'
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{
                                                            child
                                                                .opportunityItem
                                                                .daysAsAnOpp ||
                                                                '-'
                                                        }}
                                                    </td>
                                                </ng-container>
                                            </tr>
                                        </tbody>
                                    </ng-template>
                                </ng-container>
                            </table>
                        </div>
                        <div
                            class="button-wrapper"
                            *ngIf="
                                item.hasShowMore &&
                                item.type !== _cardItemType.PENDING_COMMITMENTS
                            "
                        >
                            <button
                                class="show-more-btn cmps-button--no-bg"
                                cmpsButton
                                (click)="_onShowMoreClick(i)"
                            >
                                {{
                                    (!item.isShowMoreEnabled
                                        ? _i18n._9407_SHOW_LESS
                                        : _i18n._9408_SHOW_MORE
                                    ) | translate
                                }}
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
            <ng-template
                #noOpportunities
                let-item
            >
                <h6 class="no-opportunity-label">
                    {{ item.noDataLabel | translate }}
                </h6>
            </ng-template>
        </div>
        <div *ngIf="_isExpanded === true">
            <div cmpsWidgetCoachingInsightNext></div>
        </div>
    </div>
</ng-template>
